import { useCreateVariableMutation as _useCreateVariableMutation, useDeleteVariableMutation as _useDeleteVariableMutation, useDeleteVariablesMutation as _useDeleteVariablesMutation, useSearchVariablesLazyQuery as _useSearchVariablesLazyQuery, useSearchVariablesQuery as _useSearchVariablesQuery, useUpdateVariableMutation as _useUpdateVariableMutation, useUpdateVariableNameMutation as _useUpdateVariableNameMutation, } from '../generated/graphql-types';
export const useSearchVariablesQuery = (request) => {
    const { data, error, loading, refetch } = _useSearchVariablesQuery({
        variables: {
            request,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        data: data?.restapiV2__searchVariables,
        error,
        loading,
        refetch,
    };
};
export const useSearchVariablesLazyQuery = () => {
    const [searchVariablesLazy, { data, error, loading },] = _useSearchVariablesLazyQuery({
        fetchPolicy: 'network-only',
    });
    const searchVariables = (request) => {
        searchVariablesLazy({
            variables: {
                request,
            },
        });
    };
    return {
        searchVariables,
        data: data?.restapiV2__searchVariables,
        error,
        loading,
    };
};
export const useCreateVariableMutation = () => {
    const [createVariableMutation, { data, error, loading },] = _useCreateVariableMutation();
    const createVariable = async (request) => {
        const result = await createVariableMutation({
            variables: {
                request,
            },
        });
        return result.data?.restapiV2__createVariables;
    };
    return {
        createVariable,
        data,
        error,
        loading,
    };
};
export const useUpdateVariableMutation = () => {
    const [updateVariableMutation, { data, error, loading },] = _useUpdateVariableMutation();
    const updateVariable = async (request) => {
        const result = await updateVariableMutation({
            variables: {
                request,
            },
        });
        return result.data?.restapiV2__updateVariable;
    };
    return {
        updateVariable,
        data,
        error,
        loading,
    };
};
export const useDeleteVariablesMutation = () => {
    const [deleteVariablesMutation, { data, error, loading },] = _useDeleteVariablesMutation();
    const deleteVariables = async (ids) => {
        const result = await deleteVariablesMutation({
            variables: { ids },
        });
        return result.data?.restapiV2__deleteVariables;
    };
    return {
        deleteVariables,
        data,
        error,
        loading,
    };
};
export const useDeleteVariableMutation = () => {
    const [deleteVariableMutation, { data, error, loading },] = _useDeleteVariableMutation();
    const deleteVariable = async (id) => {
        const result = await deleteVariableMutation({
            variables: { id },
        });
        return result.data?.restapiV2__deleteVariable;
    };
    return {
        deleteVariable,
        data,
        error,
        loading,
    };
};
export const useUpdateVariableNameMutation = () => {
    const [updateVariableNameMutation, { data, error, loading },] = _useUpdateVariableNameMutation();
    const updateVariableName = async (identifier, name) => {
        const result = await updateVariableNameMutation({
            variables: {
                identifier,
                request: {
                    name,
                },
            },
        });
        return result.data?.restapiV2__updateVariableName;
    };
    return {
        updateVariableName,
        data,
        error,
        loading,
    };
};
//# sourceMappingURL=variables-service.js.map